<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Data Profil</section>
    <!-- Body -->
    <div class="w-full p-5">
      <form>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Nama"
              :value="pengguna.nama"
              disabled
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="NIP"
              :value="pengguna.nip"
              disabled
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Jabatan"
              :value="pengguna.jabatan.nama"
              disabled
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Alamat"
              v-model="updateData.alamat"
              name="alamat"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('alamat')">{{
              errors.first("alamat")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Telepon"
              v-model="updateData.telepon"
              name="telepon"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('telepon')">{{
              errors.first("telepon")
            }}</span>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <small>Tanggal Lahir</small>
            <datepicker
              name="tanggal-lahir"
              v-model="updateData.tgl_lahir"
              :format="'yyyy-MM-dd'"
              placeholder="Tanggal Lahir"
            >
            </datepicker>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="submit"
        >
          Update
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="cancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { UPDATE } from "@/query/pengguna";

export default {
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    pengguna: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      updateData : {
        nama : '',
        nip : '',
        jabatan_id : '',
        golongan_id : '',
        alamat : '',
        telepon : '',
        status : '',
        tgl_lahir : '',
      },
    };
  },
  mounted (){
    this.assignData();
  },
  methods: {
    async submit(){
      await this.$validator.validateAll().then(result => {
        if (result) {
          this.updateData.tgl_lahir = moment(this.updateData.tgl_lahir).format("YYYY-MM-DD");
          this.$apollo.mutate({
              mutation: UPDATE,
              variables: {
                id: this.$sanctum.getUser().id,
                input: {
                  ...this.updateData
                }
              }
          })
          .then(() => {
            this.$vs.notify({
              title: 'Berhasil melakukan update profil.',
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position : "top-right"
            });
            window.setTimeout(() => {
              this.toggleActive(false);
              this.submitCallback();
              this.$emit("submitCallback", true);
            },700);
          })
          .catch((error) => {
            console.log(error);
          })
        }
        else{
          this.$vs.notify({
            title: "Silahkan lengkapi form terlebih dahulu !",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position: "top-right"
          });
        }
      });
    },
    assignData(){
      Object.keys(this.updateData).map(item => {
        if(this.pengguna.hasOwnProperty(item)){
          this.updateData[item] = this.pengguna[item];
        }
      });
      this.updateData.jabatan_id = this.pengguna.jabatan.id;
      this.updateData.golongan_id = this.pengguna.golongan.id;
    },
    cancel() {
      this.toggleActive(false);
    },
    submitCallback() {
      this.$emit("submitCallback", true);
    },
    toggleActive(isActive) {
      this.dialog.isActive = isActive;
    },
  },
  watch: {
    "updateData.username": function() {
      this.updateData.username.length > 4 ? this.checkUsername() : "";
    }
  },
  components: {
    Datepicker
  }
};
</script>
